import config from '../config'
import query from '../api/BaseApi'

export default class movie_reports {
  constructor() {
    this.host = config.movie_host;
    this.model = 'movie_report';
  }
  async query({ host = this.host, method, urlParams, bodyPayload, pathPrefix = '/api/v1/', model = this.model, path = '', headers = null }) {
    return await query({
      host: host,
      method: method,
      urlParams: urlParams,
      bodyPayload: bodyPayload,
      pathPrefix: pathPrefix,
      model: model,
      path: path,
      headers: headers,
    })
  }
  async searchMovieReports() {
    return await this.query({
      path: "/",
      method: 'GET',
    })
  }

}